import { defineMessages, type MessageDescriptor } from "react-intl";

import type { RoomType } from "../../ListingFsvForm.consts";

// defineMessages so `extract-main` picks these up; they're looked up by room type
const ROOM_TYPE_LABELS: Record<RoomType, MessageDescriptor> = defineMessages({
  full_space_buyout: {
    id: "hosting.listing_fsv.room_type_full_space_buyout",
    defaultMessage: "Full venue",
  },
  private_room: {
    id: "hosting.listing_fsv.room_type_private_room",
    defaultMessage: "Private room",
  },
  semi_private_area: {
    id: "hosting.listing_fsv.room_type_semi_private_area",
    defaultMessage: "Semi-private room",
  },
  reserved_area: {
    id: "hosting.listing_fsv.room_type_reserved_area",
    defaultMessage: "Reserved area",
  },
});

const ROOM_TYPE_DESCRIPTIONS: Record<RoomType, MessageDescriptor> =
  defineMessages({
    full_space_buyout: {
      id: "hosting.listing_fsv.room_type_full_space_buyout_description",
      defaultMessage: "The entire venue, exclusive to the group",
    },
    private_room: {
      id: "hosting.listing_fsv.room_type_private_room_description",
      defaultMessage: "An enclosed room used only by the group",
    },
    semi_private_area: {
      id: "hosting.listing_fsv.room_type_semi_private_area_description",
      defaultMessage: "A partly open or partitioned space",
    },
    reserved_area: {
      id: "hosting.listing_fsv.room_type_reserved_area_description",
      defaultMessage: "A section set aside within a shared space",
    },
  });

export { ROOM_TYPE_DESCRIPTIONS, ROOM_TYPE_LABELS };
